<template>
  <section>
    <div class="topup-error" v-if="topupError">
      <p class="error-title">{{ $t('component.stage3.topupErrorHeader') }}</p>
      <p>{{ $t('component.stage3.topupErrorText') }}</p>
    </div>
    <form class="topup-form" @submit="submit">
      <div class="topup-form-frame">
        <div class="topup-loading" v-if="isLoading">{{ $t('component.stage3.loadingText') }}</div>
        <h1 class="step-title" v-html="$t('component.stage3.title')"></h1>
        <h2 class="dark-title" v-html="$t('component.stage3.header')"></h2>
        <div>
          <div class="topup-summary">
            <div class="topup-phones-list" v-for="(topup, topupIndex) in formData.topup" :key="topupIndex">
              <div>
                <p>
                  {{ $t('component.stage3.labelPhone') }}<br>
                  <strong>{{topup.phone | phone}}</strong>
                </p>
                <p>
                  {{ $t('component.stage3.labelAmount') }}<br>
                  <strong>{{topup.amount}} zł</strong>
                </p>
              </div>
              <div v-if="topupIndex === 0">
                <p>
                  {{ $t('component.stage3.labelEmail') }}<br>
                  <strong>{{formData.email}}</strong>
                </p>
              </div>
            </div>
          </div>
          <div class="topup-paywall" v-if="isWhiteLabelPaywallEnabled">
            <h2>Wybierz metodę płatności:</h2>
            <ul>
              <li v-for="(payway, index) in paywallGatewayList"
                  ref="paymentMethod"
                  :key="index" @click="setPaywayId(payway.gatewayId)"
                  :class="{'active': isPaywayActive(payway.gatewayId)}">
                <el-tooltip class="item" effect="dark" :content="payway.gatewayName" placement="top">
                  <img :src="payway.iconUrl" :alt="payway.gatewayName">
                </el-tooltip>
              </li>
            </ul>
            <div class="topup-form-fields" v-if="isPaywayBlik()">
              <div class="topup-form-field-zone">
                <div class="topup-form-field">
                  <div class="topup-form-field-container">
                    <label for="authorizationCode">Kod BLIK *</label>
                    <input type="text"
                           placeholder="000 000"
                           v-model="form.authorizationCode"
                           v-mask="'### ###'"
                           id="authorizationCode">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="topup-agreements">
            <div class="with-checkbox">
              <input type="checkbox" id="checkAll" v-model="checkAll" autocomplete="off" ref="checkAll" />
              <label class="check-label" for="checkAll">
                <span class="check-label-box"></span>
                <span class="check-label-text"><strong>{{ $t('component.stage3.checkAll') }}</strong></span>
              </label>
            </div>
            <div class="with-checkbox">
              <input type="checkbox" id="marketing" v-model="form.marketing" autocomplete="off" />
              <label class="check-label" for="marketing">
                <span class="check-label-box"></span>
                <span class="check-label-text" v-html="$t('component.stage3.marketingText')"></span>
              </label>
            </div>
            <div class="with-checkbox">
              <input type="checkbox" id="agreement" v-model="form.agreement" autocomplete="off" />
              <label class="check-label" for="agreement">
                <span class="check-label-box"></span>
                <span class="check-label-text" v-html="$t('component.stage3.agreementText')"></span>
              </label>
            </div>
            <div class="with-checkbox">
              <input type="checkbox" id="payment" v-model="form.payment" autocomplete="off" />
              <label class="check-label" for="payment">
                <span class="check-label-box"></span>
                <span class="check-label-text" v-html="$t('component.stage3.paymentText')"></span>
              </label>
            </div>
            <p><span class="red">*</span>&nbsp;<span v-html="$t('component.stage3.required')"></span></p>
          </div>
          <div class="rodo" v-html="$t('component.stage3.rodoText')"></div>
        </div>
      </div>
      <div class="topup-form-buttons">
        <button id="go-back-step-3" type="button" @click="goBack" :disabled="isLoading"
                :title="$t('component.autotopup.stage4.a11y.toPreviousStepButton')">‹ {{ $t('component.stage3.buttonBack') }}</button>
        <button id="submit-step-3" type="submit" :disabled="!isFormValid() || isLoading"
                :title="$t('component.autotopup.stage4.a11y.submitButton')">{{ $t('component.stage3.buttonNext') }} ›</button>
      </div>
    </form>
  </section>
</template>

<script>
import TopupStep3Mixin from '@/common/mixins/Topup/Stage3.mixin'

export default {
  name: 'TopupStage3',
  mixins: [TopupStep3Mixin],
  mounted () {
    let focusArea = this.$refs.checkAll
    if (focusArea) {
      focusArea.focus()
    }
  }
}
</script>

<style src="../../../assets/scss/topup-main.scss" lang="scss"></style>
